export default function  getCookie(name:string) {     
    const match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));     
    return match ? match[1] : null; 
}